<div class="add-button">
    <ham-button outline="true" [size]="'xs'" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="addRow()">
        {{ 'aumico_annual_report_proposal_add_new_item' | i18next }}
    </ham-button>
</div>
<div class="profit-calculation-table" *ngIf="form">
    <form [formGroup]="form">
        <ng-container formArrayName="dataSource">
            <table>
                <thead>
                    <tr>
                        <th>
                            <ham-inline-table-cell-edit
                                [value]="
                                    profitCalcaulationHeaderText ||
                                    ('aumico_annual_report_profit_calculation_header'
                                        | i18nextWithLocale : reportLocale)
                                "
                                (save)="onSaveProfitCalculationText($event)"
                            ></ham-inline-table-cell-edit>
                        </th>
                        <th class="aumHighlight">
                            <span>{{ currentYearDate | dateLocale }}</span>
                        </th>
                        <th>
                            <span>{{ previousYearDate | dateLocale }}</span>
                        </th>
                        <th></th>
                    </tr>
                </thead>

                <!-- Table Body -->
                <tbody>
                    <tr class="label">
                        <td class="flex">
                            <span></span>
                            <span>{{ 'aumico_reports_aop_account_caption' | i18next }}</span>
                        </td>
                        <td class="aumHighlight"></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr
                        *ngFor="let element of dataSource.controls; let rowIndex = index"
                        [formGroup]="element"
                        [formGroupName]="rowIndex"
                    >
                        <!-- Name Column -->
                        <td class="aumText flex">
                            <ng-container *ngIf="rowIndex === 0">
                                <div class="dropdown-container">
                                    <input
                                        hamSimpleDropDown
                                        [options]="balanceAccounts"
                                        [optionKeys]="['name']"
                                        [extraLabel]="['extraLabel']"
                                        returnKey="accountNumber"
                                        [returnObject]="true"
                                        [placeholder]="'aumico_annual_report_aop_accounts_placeholder' | i18next"
                                        [multiple]="false"
                                        [formControl]="getFormControl('name', rowIndex)"
                                    />
                                </div>
                                <input
                                    hamInput
                                    [formControl]="getFormControl('customAccountName', rowIndex)"
                                    placeholder="{{
                                        'aumico_annual_report_aop_profit_calculation_custom_account_name_placeholder'
                                            | i18next
                                    }}"
                                    class="custom-name"
                                />
                            </ng-container>

                            <!-- Each Extra Row -->
                            <ng-container
                                *ngIf="
                                    rowIndex !== 0 &&
                                    rowIndex !== dataSource.length - 1 &&
                                    rowIndex !== dataSource.length - 2
                                "
                            >
                                <input
                                    [formControl]="getFormControl('name', rowIndex)"
                                    placeholder="{{ 'aumico_annual_report_profit_calculation_enter_text' | i18next }}"
                                    hamInput
                                />
                            </ng-container>

                            <!-- Profit -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                <input
                                    [formControl]="annualProfitName"
                                    placeholder="{{ 'aumico_annual_report_profit_calculation_enter_text' | i18next }}"
                                    hamInput
                                />
                            </ng-container>

                            <!-- Available Retained Earnings -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                <ham-inline-table-cell-edit
                                    [value]="
                                        availableRetainedEarningText ||
                                        ('aumico_annual_report_proposal_available_retained_earnings'
                                            | i18nextWithLocale : reportLocale)
                                    "
                                    (save)="onSaveAvailableRetainedEarnings($event)"
                                ></ham-inline-table-cell-edit>
                            </ng-container>
                        </td>

                        <!-- Current Value Column -->
                        <td
                            class="aumHighlight aumTextCell"
                            [ngClass]="{
                                todoHighlight: !getFormControl('currentValue', rowIndex)?.value && rowIndex !== 0
                            }"
                        >
                            <ng-container *ngIf="rowIndex === 0">
                                <aum-form-field-label>
                                    {{
                                        accountClosingAmount != null
                                            ? (accountClosingAmount | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>

                            <!-- Input for Extra Rows -->
                            <ng-container
                                *ngIf="
                                    rowIndex !== 0 &&
                                    rowIndex !== dataSource.length - 2 &&
                                    rowIndex !== dataSource.length - 1
                                "
                            >
                                <input
                                    type="number"
                                    class="number-input"
                                    hamInput
                                    [formControl]="getFormControl('currentValue', rowIndex)"
                                    placeholder="{{ 'aumico_annual_report_profit_calculation_enter_text' | i18next }}"
                                />
                            </ng-container>

                            <!-- Annual Profit -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                <aum-form-field-label>
                                    {{
                                        currentAnnualProfit != null
                                            ? (currentAnnualProfit | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>

                            <!-- Available Retained Earnings -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                <aum-form-field-label>
                                    {{
                                        currentAvailableRetainedEarnings != null
                                            ? (currentAvailableRetainedEarnings | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>
                        </td>

                        <!-- Previous Value Column -->
                        <td
                            class="aumTextCell"
                            [ngClass]="{
                                todoHighlight: !getFormControl('previousValue', rowIndex)?.value && rowIndex !== 0
                            }"
                        >
                            <ng-container *ngIf="rowIndex === 0">
                                <aum-form-field-label>
                                    {{
                                        accountOpeningAmount != null
                                            ? (accountOpeningAmount | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>

                            <!-- Input for Extra Rows -->
                            <ng-container
                                *ngIf="
                                    rowIndex !== 0 &&
                                    rowIndex !== dataSource.length - 2 &&
                                    rowIndex !== dataSource.length - 1
                                "
                            >
                                <input
                                    hamInput
                                    type="number"
                                    class="number-input"
                                    [formControl]="getFormControl('previousValue', rowIndex)"
                                    placeholder="{{ 'aumico_annual_report_profit_calculation_enter_text' | i18next }}"
                                />
                            </ng-container>

                            <!-- Annual Profit -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                <aum-form-field-label>
                                    {{
                                        previousAnnualProfit != null
                                            ? (previousAnnualProfit | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>

                            <!-- Available Retained Earnings -->
                            <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                <aum-form-field-label>
                                    {{
                                        previousAvailableRetainedEarnings != null
                                            ? (previousAvailableRetainedEarnings | finNumber : numberFormat)
                                            : ''
                                    }}
                                </aum-form-field-label>
                            </ng-container>
                        </td>

                        <!-- Remove Column -->
                        <td [ngClass]="{ aumEdit: rowIndex > 0 }">
                            <ng-container
                                *ngIf="
                                    rowIndex !== 0 &&
                                    rowIndex !== dataSource.length - 2 &&
                                    rowIndex !== dataSource.length - 1
                                "
                            >
                                <span class="ham-icon" (click)="removeAt(rowIndex)">
                                    <i class="grey-remove-icon"></i>
                                </span>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </form>
</div>
